import { render, staticRenderFns } from "./ReferraDepartmentEdit.vue?vue&type=template&id=126ed3a0&scoped=true"
import script from "./ReferraDepartmentEdit.vue?vue&type=script&lang=js"
export * from "./ReferraDepartmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126ed3a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('126ed3a0')) {
      api.createRecord('126ed3a0', component.options)
    } else {
      api.reload('126ed3a0', component.options)
    }
    module.hot.accept("./ReferraDepartmentEdit.vue?vue&type=template&id=126ed3a0&scoped=true", function () {
      api.rerender('126ed3a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/referralDepartment/ReferraDepartmentEdit.vue"
export default component.exports